module.exports = __webpack_public_path__ + "img/humla.838db67e.png";